export default "<div mat-dialog-content>\n\n</div>\n";